var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.landSize)?_c('span',[_c('span',[_vm._v(_vm._s(_vm.landSize.landSize))]),_vm._v("   "),_c('small',[_vm._v(_vm._s(_vm.landSize.unit))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }